import { useContext } from 'react';

import { DecisionTreeContext } from './DecisionTreeContext';

export const useDecisionTree = () => {
  const context = useContext(DecisionTreeContext);
  return context;
};
